var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tab-item',[_c('h3',{staticClass:"text-h6 font-weight-bold"},[_vm._v("案件詳細")]),_vm._v(" "),(_vm.matter)?_c('MatterInfo',{attrs:{"matter":_vm.matter,"dialogMode":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }